/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useState } from "react";
import { Modal, ModalBody, ModalClose, ModalContent, ModalFooter, ModalHeader, ModalTitle, ModalTrigger } from "../ui/Modal";
import Button from "../ui/Button";
import ButtonGroup from "../ui/ButtonGroup";
import Text from "../ui/Text";
import { useCancelRecurringProfile } from "../../lib/react-query/useCancelRecurringProfile";
import { extractErrorMessage } from "../../utils/api/apiErrors";

const CancelRecurringModal = ({ recurringProfileId, trigger, onCancelled }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error, setError] = useState(null);
  const { mutate, isPending } = useCancelRecurringProfile(recurringProfileId);

  const handleClose = () => {
    setIsModalOpen(false);
    error && setError(null);
  };

  const handleConfirm = () => {
    mutate(undefined, {
      onSuccess: () => {
        setIsModalOpen(false);
        onCancelled && onCancelled();
      },
      onError: (err) => setError(extractErrorMessage(err, "Something went wrong")),
    });
  };

  return (
    <Modal isOpen={isModalOpen} onOpen={() => setIsModalOpen(true)} onClose={handleClose}>
      {trigger && <ModalTrigger>{trigger}</ModalTrigger>}
      <ModalContent>
        <ModalHeader>
          <ModalTitle>membership_recurring_cancellation_dialog_title</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <Text color="dark">{error ? error : "membership_recurring_cancellation_dialog_body"}</Text>
        </ModalBody>
        <ModalFooter>
          {!error ? (
            <ButtonGroup itemsWidth="half">
              <ModalClose>
                <Button variant="outline" title="Back" />
              </ModalClose>
              <Button variant="primary" title="cancel recurring" onClick={handleConfirm} loading={isPending} />
            </ButtonGroup>
          ) : (
            <ButtonGroup itemsWidth="half" justify="end">
              <ModalClose>
                <Button variant="primary" title="Okay" onClick={handleClose} />
              </ModalClose>
            </ButtonGroup>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CancelRecurringModal;
